const Constant = {
  // Http error title
  ERROR_TITLE_400: "Bad Request",
  ERROR_TITLE_401: "Unauthorized",
  ERROR_TITLE_404: "Page Not Found",
  ERROR_TITLE_500: "Internal Server Error",
  ERROR_TITLE_0: "Unknown Error",
  HTTP_STATUS_400: "400",
  HTTP_STATUS_401: "401",
  HTTP_STATUS_404: "404",
  HTTP_STATUS_500: "500",
  HTTP_STATUS_200: "200",

  ADD: "Add",
  EDIT: "Edit",
  CLOSED: "Closed",
  SAVE_AND_CLOSE: "Save & Close",
  ENABLED: "Enabled",
  RESET_BUTTON_LABEL: "Reset",

  // constant can used in Vue template for HTML purpose
  DATE_FORMAT_LOWERCASE: "MM/dd/yyyy HH:mm",
  DATE_FORMAT_EXPORT: "MMDDYYYYHHmmss",
  DATE_FORMAT_TEXT: "MM/DD/YYYY",
  DATE_FORMAT_UPERCASE: "MM-DD-YYYY",
  TIME_FORMAT: "HH:mm",
  PHONE_INVALID: "{0} is invalid",
  PHONE_MASK: "(000) 000-0000",
  DATE_FORMAT: "mm/dd/yy",

  // Browsers name constant
  EDGE: "edge",
  OPERA: "opera",
  CHROME: "chrome",
  OPR: "opr",
  TRIDENT: "trident",
  IE: "ie",
  FIREFOX: "firefox",
  SAFARI: "safari",
  OTHER: "other",

  // Data Table no records found constant
  NO_RECORDS_FOUND: "No records found",
  NO_RECORDS_FOUND_EMPLOYEE_VIEW: "No {module} Added",

  // Default Image
  AVATAR_IMAGE: "https://ot360dev.azureedge.net/master/avatar-img.jpg",

  // Default Description length
  DESCRIPTION_LENGTH: 50,
  INCENTIVE_DESCRIPTION_LENGTH: 25,
  PAGE_DEFAULT_SIZE: 10,
  PAGE_OPTIONS: [10, 25, 50],
  TRAINING_REPORT_FILENAME: "TrainingReport_",

  // Data Table Constants
  ROWS: 10,
  PAGINATOR_TEMPLATE:
    "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
  CURRENT_PAGE_REPORT_TEMPLATE: "Showing {first} to {last} of {totalRecords}",
  PAGE_LINK_SIZE: 3,
};

export default Constant;
